/**
 * @fileoverview Frozen enumerations for @puffin-core/brand-assets (ESM).
 *
 * Mirrors `../constants.js` (CJS). Vite + native Node ESM consumers
 * import named exports here; static parse-time analysis works because
 * the file uses native `export` syntax instead of `module.exports`.
 *
 * @module @puffin-core/brand-assets/constants
 */

export const APP_KEYS = Object.freeze([
  'parcel',
  'patrol',
  'payday',
  'planner',
  'prep',
  'port',
  'palm',
  'purchase',
  // PROSPECT-001 (2026-06-13; brand finalized Phase 15) — ProspectPuffin
  // business-development app (Driftwood brand). Mirrors ../constants.js (CJS).
  'prospect',
  // Goldmark and ProtectorPuffin are TENANTS, not ParcelPuffin brands (LIFE-SHORTLISTED-001 Q-LS-32).
  // Mirrors ../constants.js (CJS).
  'console',
]);

export const ASSET_VARIANTS = Object.freeze([
  'glyph',
  'glyph512',
  'favicon16',
  'favicon32',
  'favicon48',
  'appleTouch',
  'androidChrome192',
  'androidChrome512',
  'ogCard',
]);

export const PALETTE_TOKENS = Object.freeze([
  '--puffin-black',
  '--puffin-dark-blue',
  '--puffin-green',
  '--puffin-orange',
  '--puffin-yellow',
  '--puffin-teal',
  '--puffin-light-blue',
  '--puffin-red',
  // PROSPECT-001 — Driftwood #856D55 for ProspectPuffin
  // (Puffin Logo COLORS v03.pdf). Mirrors ../constants.js (CJS).
  '--puffin-driftwood',
]);

/**
 * The review platforms a brand may name a target on (LINKABLE-ASSETS-001 E3). Mirrors
 * ../constants.js (CJS).
 *
 * @type {ReadonlyArray<string>}
 */
export const REVIEW_PLATFORMS = Object.freeze(['g2', 'capterra', 'google']);

/**
 * Each review platform's display name — a MARK, never translated. Mirrors ../constants.js (CJS).
 *
 * @type {Readonly<Record<string, string>>}
 */
export const REVIEW_PLATFORM_LABELS = Object.freeze({
  g2: 'G2',
  capterra: 'Capterra',
  google: 'Google',
});
